import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React from "react";
import { Dimensions, Platform } from 'react-native';
import i18n from "i18n-js";
import { ScrollView } from "react-native-gesture-handler";
import { useDispatch, useSelector } from "react-redux";
import { switchScreen } from '@/hooks/navigate';
import BasicButton from "@/components/basic/BasicButton";
import CancelButton from "@/components/basic/CancelButton";
import { clearMessage } from "@/stores/mainSlice";

export default function ModalMessage({ route, navigation }) {
    const { message, back, screen, p1, p2 } = route.params
    const isSimulator = message?.isSimulator ?? false

    const dispatch = useDispatch()
    const workflows = useSelector((state) => state.workflows)

    const { width: screenWidth } = Dimensions.get('window');

    const Notify = ({ screen, task }) => {

        const notifyNavigation = (screen, p1, p2) => {
            switch (screen) {
                case 'ShowStep':
                    // if (navigation.popToTop) {
                    //     // works only with stack navigators
                    //     navigation.popToTop()
                    // }
                    if (task && task.step > -1) {
                        navigation.replace('Workflows')
                        switchScreen(navigation, 'ShowWorkflow2', { taskid: p1, isLoading: false, isSimulator })
                        switchScreen(navigation, 'ShowStep', { taskid: p1, idx: +p2, isSimulator })
                    } else {
                        console.log('NTFY OLD TIMER', workflows[p1]?.step)
                        switchScreen(navigation, 'BACK')
                    }
                    dispatch(clearMessage())
                    break
                default:
                    console.log('NOTFY', route.params)
            }
            console.log('NOTIFY >', navigation.getState().routes.map(route => route.name))
        }

        return (
            <View className="flex-1 bg-[#00000050] justify-center">
                {task && task.step > -1 ?
                    <VStack space='md' className={` width-${0.95*screenWidth} m-3 bg-secondary-50 px-4 py-5 rounded-[5px] max-w-[480px] self-center `}>
                        <Text bold className="text-2xl text-secondary-900 bg-secondary-50 py-2">{i18n.t('message.timerDone')}</Text>
                        <Text bold className="text-xl text-secondary-900 bg-secondary-50">{task.title}</Text>
                        <Text className="font-[400] text-xl text-secondary-900 bg-secondary-50">{i18n.t('message.showStep', { idx: task.step + 1, title: task.steps[task.step].title })}</Text>
                        <VStack space='sm' className="pt-3">
                            <BasicButton onPress={() => { notifyNavigation(screen, task.id, task.step) }} text={i18n.t('message.backToTask')} />
                            <CancelButton onPress={() => { switchScreen(navigation, 'BACK'); dispatch(clearMessage()) }} text={i18n.t('message.back')} />
                        </VStack>
                    </VStack>
                    :
                    <VStack space='md' className={` ${Platform.OS == 'web' ? "self-center" : "self-stretch"} m-3 bg-secondary-50 px-4 py-5 rounded-[5px] max-w-[480px] `}>
                        <Text bold className="text-2xl text-secondary-900 bg-secondary-50 py-2">{i18n.t('message.notifyOld')}</Text>
                        <CancelButton onPress={() => { switchScreen(navigation, 'BACK'); dispatch(clearMessage()) }} text={i18n.t('message.back')} />
                    </VStack>
                }
            </View>
        );
    }


    if (screen) {
        console.log('NOTIFY <', navigation.getState().routes.map(route => route.name), route.params)
        const task = workflows[p1]
        return <Notify screen='ShowStep' task={task} />;
    } else {
        if (message.text === 'message.timerDone') {
            const task = workflows[message?.options?.taskid]
            return <Notify screen='ShowStep' task={task} />;
        } else {
            return (
                <View className="flex-1 bg-[#00000050] justify-center">
                    <VStack space='md' className={` ${Platform.OS == 'web' ? "self-center" : "self-stretch"} m-3 bg-secondary-50 px-4 py-5 rounded-[5px] max-w-[480px] `}>
                        <Text className="font-[400] text-2xl leading-2xl text-secondary-900">{i18n.t('message.' + message.level)}</Text>
                        <ScrollView>
                            <Text selectable={true} className={` ${message.i18n || message?.text.length < 200 ? "leading-2xl" : "leading-md"} ${message.i18n || message?.text.length < 200 ? "text-xl" : "text-sm"} mb-3 font-[400] text-secondary-900 `}>{message.i18n ? i18n.t(message.text, message.options) : message.text}</Text>
                            <BasicButton onPress={() => { (back ? switchScreen(navigation, back) : switchScreen(navigation, 'BACK')); dispatch(clearMessage()) }} text={i18n.t('addContact.ok')} />
                        </ScrollView>
                    </VStack>
                </View>
            );
        }
    }
}
